package org.moxultimate.topwithmox.utils

import com.varabyte.kobweb.compose.ui.graphics.Color

object ColorUtils {

    fun hexToColorRgb(hex: String, alpha: Float = 1.0f): Color {
        val cleanHex = hex.removePrefix("#")
        require(cleanHex.length == 6) { "Invalid hex length" }

        val r = cleanHex.substring(0, 2).toInt(16)
        val g = cleanHex.substring(2, 4).toInt(16)
        val b = cleanHex.substring(4, 6).toInt(16)

        // Color.rgba accepts (int, int, int, float) or (int, int, int, int)
        return Color.rgba(r, g, b, alpha)
    }

}